import React from "react";
import { cn } from "./cn";

/* Labelled progress across a multi-step intake: a filled bar per step with its name beneath. */
export const StepProgress = ({ steps = [], current = 1, className = "" }) => {
  const total = steps.length;
  const label = steps[current - 1];

  return (
    <div className={cn("mt-6", className)}>
      <div
        aria-hidden="true"
        className="grid gap-1.5"
        style={{ gridTemplateColumns: `repeat(${total}, minmax(0, 1fr))` }}
      >
        {steps.map((name, i) => (
          <span
            key={name}
            className={cn(
              "h-1 rounded-full transition-colors",
              i + 1 <= current ? "bg-[var(--orange)]" : "bg-[var(--field-inset)]"
            )}
          />
        ))}
      </div>

      {/* Phones: the five names cannot sit side by side legibly, so only the
          current one is shown; from sm up the full set appears. */}
      <div
        aria-hidden="true"
        className="mt-2 hidden gap-1.5 sm:grid"
        style={{ gridTemplateColumns: `repeat(${total}, minmax(0, 1fr))` }}
      >
        {steps.map((name, i) => (
          <span
            key={name}
            className={cn(
              "truncate text-[11px] uppercase tracking-[0.04em] font-sans",
              i + 1 === current
                ? "font-bold text-[var(--ink)]"
                : i + 1 < current
                ? "font-medium text-[var(--ink-2)]"
                : "font-medium text-[var(--muted)]"
            )}
          >
            {name}
          </span>
        ))}
      </div>
      <div
        aria-hidden="true"
        className="mt-2 text-[11px] font-bold uppercase tracking-[0.04em] text-[var(--ink)] font-sans sm:hidden"
      >
        {label}
      </div>

      <span className="sr-only">{`Step ${current} of ${total} — ${label}`}</span>
    </div>
  );
};

export default StepProgress;
